// IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): колонка грида с editor: 'color' (бэк PR #477: doc.nodes.color схемы данных,
// описание колонки — {binding: 'color', attr_type: 'AttrStr', editor: 'color'}; в форме записи / карточке строки AttrTabGrid — то же поле строкой: dataItem.attr.editor).
// Ячейка: образец цвета (квадратик) + hex-текст, пустое — пусто. Правка: штатный текстовый редактор wijmo (ручной ввод hex) + всплывающий PrimeVue ColorPicker (inline) под ячейкой;
// выбор в палитре пишет '#RRGGBB' в редактор, Enter / «Apply» / уход фокуса — коммит тем же путём, что у прочих ячеек (cellEditEnding2: undo, пометка Save), Esc — отмена.
// Чистые функции — здесь (tests/unit/gridColorEditor.test.mjs), DOM и редактор — AttrGrid.vue (colorEd_* / colorCell_apply). Выключатель fe.ux.gridColorEditor (дефолт ВКЛ;
// выкл — обычный текстовый редактор и текст без образца).
export const COLOR_EDITOR_FLAG = 'fe.ux.gridColorEditor'

export function colorEditorOn(setting) {
    try { return (typeof setting === 'function' ? setting(COLOR_EDITOR_FLAG, true) : true) !== false } catch (err) { return true }
}

// поле / колонка с редактором цвета
export function isColorAttr(attr) {
    return !!(attr && typeof attr === 'object' && attr.editor === 'color')
}

// описание поля с редактором цвета для ячейки: колонка грида (attr_col.editor) либо строка-поле формы записи AttrTabGrid (колонка значения attr.valueStr, поле — dataItem.attr)
export function colorAttrFor(attrCol, dataItem, gridAttrType, colBinding) {
    if (isColorAttr(attrCol)) return attrCol
    if (gridAttrType === 'AttrTabGrid' && colBinding === 'attr.valueStr' && dataItem && isColorAttr(dataItem.attr)) return dataItem.attr
    return null
}

const HEX3 = /^#?([0-9a-f])([0-9a-f])([0-9a-f])$/i
const HEX6 = /^#?([0-9a-f]{6})$/i

// '#RRGGBB' (заглавные) из '#rgb' / 'rgb' / '#rrggbb' / 'rrggbb' (пробелы по краям — прочь); пусто (null / undefined / '') — ''; не цвет — null
export function colorNorm(v) {
    if (v === null || v === undefined) return ''
    const s = String(v).trim()
    if (!s) return ''
    let m = HEX6.exec(s)
    if (m) return '#' + m[1].toUpperCase()
    m = HEX3.exec(s)
    if (m) return ('#' + m[1] + m[1] + m[2] + m[2] + m[3] + m[3]).toUpperCase()
    return null
}

// значение для PrimeVue ColorPicker (format 'hex': 'rrggbb' без '#'); пусто / не цвет — null (палитра встанет на свой defaultColor)
export function colorPickerValue(v) {
    const n = colorNorm(v)
    return n ? n.slice(1).toLowerCase() : null
}

// значение палитры ('rrggbb' / '#rrggbb' / объект {r,g,b}) → '#RRGGBB'; не цвет — ''
export function colorFromPicker(v) {
    if (v && typeof v === 'object' && ['r', 'g', 'b'].every(k => Number.isFinite(+v[k]))) {
        return '#' + ['r', 'g', 'b'].map(k => Math.max(0, Math.min(255, Math.round(+v[k]))).toString(16).padStart(2, '0')).join('').toUpperCase()
    }
    return colorNorm(v) || ''
}

// что показывает ячейка: swatch — цвет образца ('#RRGGBB') или null; text — текст ячейки (как есть); invalid — непустой текст, который не цвет
export function colorCellView(v) {
    const text = v === null || v === undefined ? '' : String(v)
    const n = colorNorm(text)
    return { swatch: n || null, text, invalid: n === null }
}

// значение на запись (ввод в редакторе, вставка, выбор): цвет — '#RRGGBB'; пусто — ''; не цвет — как введено (текст не теряется, ячейка покажет его без образца)
export function colorCommitValue(v) {
    if (typeof v !== 'string') return v
    const n = colorNorm(v)
    return n === null ? v : n
}

// позиция всплывающей палитры: под ячейкой по левому краю; не помещается снизу — над ячейкой; по горизонтали — в пределах окна (отступ pad)
export function colorPopupPos(rect, popW, popH, viewW, viewH, pad = 4) {
    const r = rect || { left: 0, top: 0, bottom: 0, right: 0 }
    let left = r.left
    let top = r.bottom + 2
    if (top + popH > viewH - pad && r.top - popH - 2 >= pad) top = r.top - popH - 2
    if (left + popW > viewW - pad) left = viewW - pad - popW
    if (left < pad) left = pad
    if (top < pad) top = pad
    return { left: Math.round(left), top: Math.round(top) }
}

// текст образца для «читаемого» контраста: светлый фон — тёмная рамка (у #FFFFFF и близких образец без рамки потерялся бы на белой ячейке)
export function colorIsLight(hex) {
    const n = colorNorm(hex)
    if (!n) return false
    const r = parseInt(n.slice(1, 3), 16), g = parseInt(n.slice(3, 5), 16), b = parseInt(n.slice(5, 7), 16)
    return (0.299 * r + 0.587 * g + 0.114 * b) > 200
}
